import React from "react";
import { renderAmount } from "../../../utils";
import { useConfig } from "../../../hooks/useConfig";
import { getProductTerminology } from "../../../constants/product-terminology";

const JobSummary = ({ jobTotals = {}, useFlatRate }) => {
  const { appType } = useConfig();
  const terms = getProductTerminology(appType);
  const {
    totalMiles = 0,
    totalWeight = 0,
    totalBaseCharges = 0,
    totalFuelSurcharges = 0,
    totalDropCharges = 0,
    totalCharges = 0,
  } = jobTotals;

  return (
    <div className="mt-2 pt-2 border-t border-neutral-200">
      <div className="text-xs font-medium text-neutral-600 mb-2">
        {terms.jobSummarySection}
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
        <div className="text-center bg-slate-50 rounded-md py-2 px-1">
          <div className="text-sm font-semibold text-slate-800">
            {totalMiles.toLocaleString()}
          </div>
          <div className="text-xs text-slate-600">Miles</div>
        </div>
        <div className="text-center bg-slate-50 rounded-md py-2 px-1">
          <div className="text-sm font-semibold text-slate-800">
            {totalWeight.toLocaleString()}
          </div>
          <div className="text-xs text-slate-600">lbs</div>
        </div>
        {!useFlatRate && (
          <>
            <div className="text-center bg-slate-50 rounded-md py-2 px-1">
              <div className="text-sm font-semibold text-slate-900">
                {renderAmount(totalBaseCharges)}
              </div>
              <div className="text-xs text-slate-600">Base</div>
            </div>
            <div className="text-center bg-slate-50 rounded-md py-2 px-1">
              <div className="text-sm font-semibold text-slate-900">
                {renderAmount(totalFuelSurcharges)}
              </div>
              <div className="text-xs text-slate-600">Fuel</div>
            </div>
          </>
        )}
        {!useFlatRate && totalDropCharges > 0 && (
          <div className="text-center bg-slate-50 rounded-md py-2 px-1">
            <div className="text-sm font-semibold text-slate-900">
              {renderAmount(totalDropCharges)}
            </div>
            <div className="text-xs text-slate-600">Drop</div>
          </div>
        )}
        <div className="text-center bg-green-50 rounded-md py-2 px-1">
          <div className="text-sm font-semibold text-green-700">
            {renderAmount(totalCharges)}
          </div>
          <div className="text-xs text-green-600">Total</div>
        </div>
      </div>
    </div>
  );
};

export default JobSummary;
